import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import './NewsPageId.css';
import { Tooltip} from '@mui/material';
import { FaNewspaper} from "react-icons/fa";

const NewsPageId = () => {
    const [newsData, setNewsData] = useState(null);
    const [isLoading, setIsLoading] = useState(true); // State to handle loading
    const {i18n} = useTranslation();
    const {id} = useParams();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetNewsById?Id=${id}`);
                setTimeout(() => {
                    setNewsData(response.data);
                    setIsLoading(false);
                }, Math.max(0, 500 - (Date.now() - startTime)));
            } catch (error) {
                console.error('Error fetching news data:', error);
                setIsLoading(false);
            }
        };

        const startTime = Date.now();
        void fetchData();
    }, [id]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const dateOptions = {day: '2-digit', month: '2-digit', year: 'numeric'};
        const timeOptions = {hour: '2-digit', minute: '2-digit', hour12: false}; // 24-hour format

        const formattedDate = date.toLocaleDateString('en-GB', dateOptions);
        const formattedTime = date.toLocaleTimeString('en-GB', timeOptions);

        return `${formattedDate}, ${formattedTime}`; // Combines date and time
    };


    return (
        <div className="body-background">
            <div className="news-page-id-container slide-in-input">
                {isLoading ? (
                    <div className="loader-container-news">
                        <div style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
                            <FaNewspaper style={{fontSize: 80, color: '#1A9AEE'}} className={"pulse-element"}/>
                            <h1>გთხოვთ დაელოდოთ...</h1>
                        </div>
                    </div>
                ) : (
                    newsData && newsData.data && (
                        <>
                            <p className="news-date">{formatDate(newsData.data.cereateDate)}</p>
                            <h1 className="news-page-id-title">
                                {i18n.language === 'geo' ? newsData.data.title : newsData.data.titleEng}
                            </h1>

                            {newsData.data.path !== null && (
                                <Tooltip title={i18n.language === 'geo' ? newsData.data.title : newsData.data.titleEng}>
                                <span>
                                    <img src={newsData.data.path} alt="news" className="news-page-id-image"/>
                                </span>
                                </Tooltip>
                            )}

                            <div
                                className="news-page-id-description"
                                dangerouslySetInnerHTML={{__html: i18n.language === 'geo' ? newsData.data.description : newsData.data.descriptionEng}}
                            />
                        </>
                    )
                )}
            </div>
        </div>
    );
};

export default NewsPageId;
